export enum HubspotEnrichmentFetchFilterTypeEnum {
  EMPTY = "EMPTY",
  FIELD = "FIELD",
  CUSTOM = "CUSTOM",
}
